<template lang="html">
  <section class="popup-pdf-seguridad" @keypress.esc="changeState">
    <div class="contenedor-pdfs">
      <button @click="changeState">✕</button>
      <p>{{$t('productos.titulo_banner')}}</p>
      <ul>
        <template v-for="idioma in languages">
          <li class="pdf-idiomas">
            <img :src="`/static/img/productos-quimicos/langs/${idioma}.webp`" alt="">
            <a v-if="type == 'seguridad'" :href="`/static/pdf/${id}/seguridad/${idioma}_${products[id]}_SAFETY_DATA_SHEET.pdf`"
              target="_blank">{{$t(`productos.idiomas['${idioma}']`)}}</a>
            <a v-if="type == 'tecnica'" :href="`/static/pdf/${id}/tecnicas/${idioma}_${products[id]}_TECHNICAL_DATA_SHEET.pdf`"
              target="_blank">{{$t(`productos.idiomas['${idioma}']`)}}</a>
          </li>
        </template>
      </ul>
    </div>
  </section>

</template>

<script lang="js">
  export default {
    name: 'popup-pdf-seguridad',
    props: ['show_popup_pdf', 'id', 'type'],
    data() {
      return {
        languages: ['GE','BG','CZ','SK', 'SL','ES','FR','GR','NL','HU','EN','IT','LT', 'LV', 'PT', 'RO', 'RU', 'SE','PL'],
        products: {
          'ajulock': 'AJULOCK',
          'ajulube': 'AJULUBE',
          'ajusil': 'AJUSIL',
          'ajustick': 'AJUSTICK',
          'ajusev': 'AJUSEV',
        }
      }
    },
    methods: {
      changeState() {
        this.$emit('update:show_popup_pdf', false)
      },
    },
  }
</script>

<style scoped>
  .popup-pdf-seguridad {
    position: fixed;
    z-index: 100;
    background: #0000007d;
    height: 100vh;
    width: 100vw;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .contenedor-pdfs {
    background: white;
    padding: 35px 25px;
    position: relative;
    margin: 15px;
    max-width: 730px;
    width: 100%;
  }

  .contenedor-pdfs ul{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }

  .contenedor-pdfs li{
    width: 33.33333%;
  }

  .contenedor-pdfs button {
    position: absolute;
    top: -50px;
    right: 0;
    background: transparent;
    color: #E6ECF1;
    font-size: 30px;
    border: 0;
    cursor: pointer;
  }

  .contenedor-pdfs button:focus {
    outline: none;
  }

  .contenedor-pdfs p {
    margin-bottom: 25px;
    text-align: center
  }

  .pdf-idiomas {
    display: flex;
    align-items: baseline;
    margin: 5px 0;
  }

  .pdf-idiomas img {
    max-width: 25px;
    width: 100%;
    margin-right: 10px;
  }

  @media screen and (max-width:500px){

    .contenedor-pdfs{
      max-width: 300px;
    }

    .contenedor-pdfs li{
      width: 50%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/view-parts/popup-pdf-seguridad.vue